// extracted by mini-css-extract-plugin
export var infoSection = "_d-1";
export var infoSectionContainer = "_d-0";
export var infoSectionTitleRow = "_d-2";
export var multiLineInfo = "_d-4";
export var strong = "_d-3";